var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ActionButton from '../../../ActionButton';
import LabelStatus from '../../../LabelStatus';
import Tag from '../../../Pill';
import { BottomRightElementsWrapper, HeaderShimmerWrapper, HeaderWrapper, IconWrapper, LeftElementsWrapper, } from './CustomCard.HeaderElements';
import CustomCardHeaderTag from './CustomCard.HeaderTag';
var CustomCardHeaderContent = function (props) {
    var headerProps = props.headerProps, size = props.size, _a = props.loading, loading = _a === void 0 ? false : _a;
    var _b = headerProps || {}, labelStatus = _b.labelStatus, pill = _b.pill, tag = _b.tag;
    if (!headerProps)
        return null;
    var pillElement = (pill === null || pill === void 0 ? void 0 : pill.label) ? _jsx(Tag, __assign({}, pill)) : undefined;
    var labelStatusElement = labelStatus && _jsx(LabelStatus, __assign({}, labelStatus));
    var HeaderContainer = loading ? HeaderShimmerWrapper : HeaderWrapper;
    return (_jsxs(HeaderContainer, __assign({ heroUrl: headerProps === null || headerProps === void 0 ? void 0 : headerProps.heroUrl, size: size }, { children: [(headerProps === null || headerProps === void 0 ? void 0 : headerProps.icon) && !loading && _jsx(IconWrapper, { children: headerProps.icon }), _jsxs(LeftElementsWrapper, { children: [!loading && pillElement, !loading && labelStatusElement, !loading && (headerProps === null || headerProps === void 0 ? void 0 : headerProps.actionButton) && _jsx(ActionButton, __assign({}, headerProps.actionButton))] }), tag && (_jsx(BottomRightElementsWrapper, __assign({ size: size }, { children: _jsx(CustomCardHeaderTag, __assign({}, tag, { loading: loading })) })))] })));
};
export default CustomCardHeaderContent;
